/* global axios */
import ApiClient from './ApiClient';

class LaisCrmConfigAPI extends ApiClient {
  constructor() {
    super('lais/crm_config', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  save(payload) {
    return axios.patch(this.url, payload);
  }

  test(payload) {
    return axios.post(`${this.url}/test`, payload);
  }

  activate(payload = {}) {
    return axios.post(`${this.url}/activate`, payload);
  }
}

export default new LaisCrmConfigAPI();
